import apiCall from 'apps/futureflex/apiCalls/employeeProgram';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/AdminCRUD/page';
import FilterForm from './FilterForm';
import ItemForm from './Form';

import { employeeProgramsColumnsGenerator } from './config';
import ItemDetail from './detail';
import Portfolio from './portfolio';

export const ProgramDetailListPage = (props, { params }) => {
  return (
    <ListPage
      enableSearch={true}
      FilterForm={FilterForm}
      title="All Flex Programs"
      apiCall={apiCall}
      params={params}
      createUrl={`/futureflex/employee-programs/create`}
      columnGenerator={() => employeeProgramsColumnsGenerator()}
      resourceName="data"
      {...props}
    />
  );
};

export const ProgramDetailDetailPage = (props, { params }) => (
  <DetailPage
    title="Flex Program Detail"
    listUrl={`/futureflex/employee-programs`}
    apiCall={apiCall}
    ItemDetail={ItemDetail}
    params={params}
    resourceName="data"
    {...props}
  />
);

export const ProgramDetailEditPage = props => (
  <EditPage
    title="Edit Flex Program"
    apiCall={apiCall}
    listUrl={`/futureflex/employee-programs`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const ProgramDetailCreatePage = props => (
  <CreatePage
    title="Create Flex Program"
    apiCall={apiCall}
    listUrl={`/futureflex/employee-programs`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const ProgramDetailPortfolioPage = props => (
  <Portfolio apiCall={apiCall} />
);
